import * as React from 'react';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { StepOne } from '../forms/UserStepper/StepOne';
import { StepTwo } from '../forms/UserStepper/StepTwo';
import { StepThree } from '../forms/UserStepper/StepThree';
import { CustomStepLabel, Wizard } from './styles';
import { AbilityContext } from '../../../Context/PermissionsContext';
import { useAbility } from '@casl/react';
import { useColors } from '../../../Context/ColorsContext';

export default function CustomStepper({
  steps,
  activeStep,
  addRole,
  form,
  data,
  roleList,
  selectedRole,
  selectedPlants,
  errors,
  setErrors,
  loading,
  authTypeRef,
  handleChangeStepOne,
  handleChangeStepTwo,
  handleSetRole,
  handleAuthentication,
  handleValidateEmail,
  validateEmail,
  buttonRef,
  handleGeneratePassword,
  showPasswordGenerator,
  setShowPasswordGenerator,
  handleGenerateClick,
  roleType,
  categories,
  plants,
  companies,
  handleFilesDrop,
  files,
  handleSetCompany,
  handleSetPlants,
  selectedCompany,
  companyContracts,
  setForm,
  user,
  isSupervisor,
  passwordPolicyData,
  showCheckSupervisor
}) {
	const { t } = useTranslation();
  const [skipped, setSkipped] = React.useState(new Set());

  const ability = useAbility(AbilityContext);

  const isStepOptional = (step) => {
    // return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const CustomStepIcon = (props) => {
    const { active, completed, className, icon } = props;
    const { colors } = useColors();

    const icons = {
      1: 'person',
      2: 'domain',
      3: 'draft',
    };

    return (
      <div
        className={className}
        style={{
          backgroundColor: active || completed 
            ? (String(icon) === '3' ? colors.sidebarSelectColor : colors.navbarColor) 
            : '#e4e7eb',
          color: active || completed ? '#fff' : '#9fa5af',
          width: 40,
          height: 40,
          display: 'flex',
          borderRadius: '50%',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1,
        }}
      >
        <span className="material-symbols-outlined" style={{ fontSize: '25px' }}>
          {icons[String(icon)]}
        </span>
      </div>
    );
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
      <Wizard activeStep={activeStep} alternativeLabel>
        {steps?.map((row, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={row.label} {...stepProps}>
              <CustomStepLabel StepIconComponent={CustomStepIcon} {...labelProps}>{row.label}</CustomStepLabel>
            </Step>
          );
        })}
      </Wizard>

      {activeStep === steps.length ? (
        <React.Fragment>
        </React.Fragment>
      ) : (
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column', overflowY: 'auto' }}>
          <div sx={{ mt: 2, mb: 1 }} style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            {activeStep === 0 &&
              <StepOne 
                form={form}
                addRole={addRole}
                roleList={roleList}
                selectedRole={selectedRole}
                errors={errors}
                loading={loading}
                authTypeRef={authTypeRef}
                handleChange={handleChangeStepOne}
                handleSetRole={handleSetRole}
                handleAuthentication={handleAuthentication}
                handleValidateEmail={handleValidateEmail}
                validateEmail={validateEmail}
                buttonRef={buttonRef}
                handleGeneratePassword={handleGeneratePassword}
                showPasswordGenerator={showPasswordGenerator}
                setShowPasswordGenerator={setShowPasswordGenerator}
                handleGenerateClick={handleGenerateClick}
                setForm={setForm}
                passwordPolicyData={passwordPolicyData}
              />
            } 
            {activeStep === 1 &&
              <StepTwo 
                data={data}
                roleType={roleType}
                handleChangeStepTwo={handleChangeStepTwo}
                form={form}
                setForm={setForm}
                categories={categories}
                plants={plants}
                companies={companies}
                handleSetCompany={handleSetCompany}
                handleSetPlants={handleSetPlants}
                selectedCompany={selectedCompany}
                selectedPlants={selectedPlants}
                companyContracts={companyContracts}
                errors={errors}
                setErrors={setErrors}
                user={user}
                isSupervisor={isSupervisor}
                showCheckSupervisor={showCheckSupervisor}
              />
            }
            {(activeStep === 2 && ability.can("UserAttachmentCreate")) &&
              <StepThree
                data={data}
                validateEmail={validateEmail}
                handleFilesDrop={handleFilesDrop}
                setForm={setForm}
                files={files}
              />
            }
          </div>
        </div>
      )}
    </Box>
  );
}
